export default state => state.category.isBrand;
